// extracted by mini-css-extract-plugin
module.exports = {"tz91tx8":"tz91tx8"};